import { c as _c } from "react/compiler-runtime";
import { HotelReservedCardPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { isFilled } from "@website/utils/is-filled";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useHotelReserveCard = properties => {
  const $ = _c(85);
  const {
    id,
    bookNeedConfirm,
    hotelId,
    provider,
    promotion,
    bookType,
    title,
    availableRooms,
    extraBed,
    hasBreakfast,
    facilities,
    price,
    pricedRoomCount,
    isRoomCountPriceAvailable,
    img,
    adults,
    isLoading,
    nightCount,
    minStay,
    priceOff,
    rackIncluded,
    description,
    onClick: onHandleClick,
    roomRacks,
    hasMorContentButton,
    onRoomCountChange,
    freeCancellation,
    cancellationPolicies,
    regularBadges,
    hotelType,
    roomDetail,
    onInView,
    snappPayData,
    notifyData,
    adjustments
  } = properties;
  const router = useRouter();
  let t0;
  if ($[0] !== availableRooms || $[1] !== router.query.no_rooms) {
    t0 = Number.isNaN(Number(router.query.no_rooms)) ? 1 : Number(router.query.no_rooms) <= availableRooms ? Number(router.query.no_rooms) : availableRooms;
    $[0] = availableRooms;
    $[1] = router.query.no_rooms;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [roomCount, setRoomCount] = useState(t0);
  let t1;
  if ($[3] !== availableRooms || $[4] !== router.query.no_rooms) {
    t1 = () => {
      setRoomCount(Number.isNaN(Number(router.query.no_rooms)) ? 1 : Number(router.query.no_rooms) <= availableRooms ? Number(router.query.no_rooms) : availableRooms === 0 ? 1 : availableRooms);
    };
    $[3] = availableRooms;
    $[4] = router.query.no_rooms;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = roomDetail?.showRoomDetail;
  const t3 = router?.query?.no_rooms;
  let t4;
  if ($[6] !== availableRooms || $[7] !== t2 || $[8] !== t3) {
    t4 = [t2, t3, availableRooms];
    $[6] = availableRooms;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t1, t4);
  const [openPackageModal, setOpenPackageModal] = useState(false);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpenPackageModal(false);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onClose = t5;
  const {
    reference,
    inView
  } = useIsVisible();
  let t6;
  let t7;
  if ($[11] !== inView || $[12] !== onInView) {
    t6 = () => {
      onInView?.(inView);
    };
    t7 = [inView, onInView];
    $[11] = inView;
    $[12] = onInView;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== roomRacks) {
    t8 = () => {
      setOpenPackageModal(isFilled(roomRacks));
    };
    $[15] = roomRacks;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const onRacksClick = t8;
  let t9;
  if ($[17] !== onRoomCountChange) {
    t9 = count => {
      setRoomCount(count);
      onRoomCountChange?.(count);
    };
    $[17] = onRoomCountChange;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const handleRoomCount = t9;
  const t10 = roomDetail?.handleShowRoomDetail;
  let t11;
  if ($[19] !== adults || $[20] !== availableRooms || $[21] !== cancellationPolicies || $[22] !== description || $[23] !== extraBed || $[24] !== facilities || $[25] !== freeCancellation || $[26] !== hasBreakfast || $[27] !== hasMorContentButton || $[28] !== id || $[29] !== img || $[30] !== rackIncluded || $[31] !== regularBadges || $[32] !== roomCount || $[33] !== t10 || $[34] !== title) {
    t11 = {
      id,
      title,
      availableRooms,
      extraBed,
      hasBreakfast,
      facilities,
      img,
      adults,
      onClick: t10,
      description,
      hasMorContentButton,
      freeCancellation,
      cancellationPolicies,
      regularBadges,
      rackIncluded,
      roomCount
    };
    $[19] = adults;
    $[20] = availableRooms;
    $[21] = cancellationPolicies;
    $[22] = description;
    $[23] = extraBed;
    $[24] = facilities;
    $[25] = freeCancellation;
    $[26] = hasBreakfast;
    $[27] = hasMorContentButton;
    $[28] = id;
    $[29] = img;
    $[30] = rackIncluded;
    $[31] = regularBadges;
    $[32] = roomCount;
    $[33] = t10;
    $[34] = title;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== adjustments || $[37] !== adults || $[38] !== availableRooms || $[39] !== bookNeedConfirm || $[40] !== bookType || $[41] !== handleRoomCount || $[42] !== hotelId || $[43] !== hotelType || $[44] !== id || $[45] !== isLoading || $[46] !== isRoomCountPriceAvailable || $[47] !== minStay || $[48] !== nightCount || $[49] !== onHandleClick || $[50] !== onRacksClick || $[51] !== price || $[52] !== priceOff || $[53] !== pricedRoomCount || $[54] !== promotion || $[55] !== provider || $[56] !== rackIncluded || $[57] !== roomCount || $[58] !== roomDetail || $[59] !== roomRacks || $[60] !== snappPayData || $[61] !== title) {
    t12 = {
      id,
      title,
      bookNeedConfirm,
      hotelId,
      provider,
      promotion,
      bookType,
      availableRooms,
      minStay,
      price,
      pricedRoomCount,
      isRoomCountPriceAvailable,
      isLoading,
      onClick: onHandleClick,
      nightCount,
      priceOff,
      rackIncluded,
      roomRacks,
      onRacksClick,
      adults,
      hotelType,
      snappPayData,
      roomDetail,
      roomCount,
      setRoomCount: handleRoomCount,
      adjustments
    };
    $[36] = adjustments;
    $[37] = adults;
    $[38] = availableRooms;
    $[39] = bookNeedConfirm;
    $[40] = bookType;
    $[41] = handleRoomCount;
    $[42] = hotelId;
    $[43] = hotelType;
    $[44] = id;
    $[45] = isLoading;
    $[46] = isRoomCountPriceAvailable;
    $[47] = minStay;
    $[48] = nightCount;
    $[49] = onHandleClick;
    $[50] = onRacksClick;
    $[51] = price;
    $[52] = priceOff;
    $[53] = pricedRoomCount;
    $[54] = promotion;
    $[55] = provider;
    $[56] = rackIncluded;
    $[57] = roomCount;
    $[58] = roomDetail;
    $[59] = roomRacks;
    $[60] = snappPayData;
    $[61] = title;
    $[62] = t12;
  } else {
    t12 = $[62];
  }
  const t13 = roomDetail?.handleShowRoomDetail;
  let t14;
  if ($[63] !== id || $[64] !== notifyData || $[65] !== roomCount || $[66] !== t13) {
    t14 = {
      id,
      onClick: t13,
      notifyData,
      roomCount
    };
    $[63] = id;
    $[64] = notifyData;
    $[65] = roomCount;
    $[66] = t13;
    $[67] = t14;
  } else {
    t14 = $[67];
  }
  const t15 = roomDetail?.handleShowRoomDetail;
  let t16;
  if ($[68] !== availableRooms || $[69] !== id || $[70] !== t15) {
    t16 = {
      id,
      availableRooms,
      onClick: t15
    };
    $[68] = availableRooms;
    $[69] = id;
    $[70] = t15;
    $[71] = t16;
  } else {
    t16 = $[71];
  }
  let t17;
  if ($[72] !== openPackageModal || $[73] !== roomRacks || $[74] !== t16 || $[75] !== title) {
    t17 = {
      open: openPackageModal,
      onClose,
      roomRacks,
      title,
      roomDetail: t16
    };
    $[72] = openPackageModal;
    $[73] = roomRacks;
    $[74] = t16;
    $[75] = title;
    $[76] = t17;
  } else {
    t17 = $[76];
  }
  let t18;
  if ($[77] !== openPackageModal || $[78] !== reference || $[79] !== roomRacks || $[80] !== t11 || $[81] !== t12 || $[82] !== t14 || $[83] !== t17) {
    t18 = {
      roomRacks,
      openPackageModal,
      onClose,
      hotelReserveCardContentProps: t11,
      hotelReserveCardFooterProps: t12,
      hotelReserveCardFullCapacityProps: t14,
      hotelReserveCardRacksProps: t17,
      reference
    };
    $[77] = openPackageModal;
    $[78] = reference;
    $[79] = roomRacks;
    $[80] = t11;
    $[81] = t12;
    $[82] = t14;
    $[83] = t17;
    $[84] = t18;
  } else {
    t18 = $[84];
  }
  return t18;
};